import { render } from "./Vignette.vue?vue&type=template&id=08ad4ce5&scoped=true"
import script from "./Vignette.vue?vue&type=script&lang=js"
export * from "./Vignette.vue?vue&type=script&lang=js"

import "./Vignette.vue?vue&type=style&index=0&id=08ad4ce5&scoped=true&lang=css"

import exportComponent from "C:\\dev-intelij\\MC-production\\widget-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ad4ce5"]])

export default __exports__